import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { notifyBuilderEvent } from "@src/store/slices/experienceBuilder/common/thunks/notifyBuilderEvent";
import {
  trackAllModsSaved,
  trackOnsiteUpsellCreationCompleted,
} from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { saveMods } from "@src/store/slices/experienceBuilder/common/utils/saveMods";

export const saveBuilder = createAsyncThunk<void, void>(
  "experienceBuilder/saveBuilder",
  (_, { dispatch, getState }) => {
    saveMods(dispatch, getState);

    void dispatch(trackAllModsSaved());
    void dispatch(trackOnsiteUpsellCreationCompleted());
    void dispatch(notifyBuilderEvent("saved"));
  }
);
